export function computeSessionState({ now, lastActivityAt, idleLimitMs, warnBeforeMs }) {
    const msUntilLogout = idleLimitMs - (now - lastActivityAt);
    if (msUntilLogout <= 0) return { phase: "expired", remainingMs: 0 };
    if (msUntilLogout <= warnBeforeMs) return { phase: "warning", remainingMs: msUntilLogout };
    return { phase: "active", remainingMs: msUntilLogout };
}

export function formatRemaining(ms) {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
}
